@if (radioOption) {
  <button
    class="flex w-full gap-x-3 justify-between p-4 cursor-pointer bg-white disabled:opacity-40"
    (click)="check()"
    [disabled]="disabled()"
    [ngClass]="{
      ' border-primaryRed': isChecked(),
      'border-borderColor border-solid border-[1px]': isOutlined(),
    }"
  >
    <div class="flex items-center gap-x-3 tablet:gap-x-6">
      <div
        class="h-6 w-6 border-2 border-grayed-600 flex justify-center items-center rounded-full flex-shrink-0"
      >
        @if (isChecked() || radioOption.isSelected) {
          <div class="bg-black h-[14px] w-[14px] rounded-full"></div>
        }
      </div>
      <div class="flex flex-col items-start">
        <div class="flex flex-col gap-y-1.5">
          <div
            *ngIf="radioOption.isActive"
            class="block tablet:hidden bg-black rounded-full px-2 py-0.5 text-xs text-white"
          >
            {{ 'shared.currentlyActive' | scTranslate | async }}
          </div>
          <div class="flex items-center gap-x-2 tablet:gap-x-4 desktop:gap-x-5">
            <div
              [ngClass]="{
                '!font-semibold': radioOption?.isSemibold,
              }"
              class="text-mobileMd tablet:text-tabletMd desktop:text-desktopMd text-left max-w-26 tablet:max-w-none"
            >
              {{ radioOption.label }}
            </div>
            <div
              *ngIf="radioOption.isActive"
              class="hidden tablet:block bg-black rounded-full px-2 py-0.5 text-xs text-white"
            >
              {{ 'shared.currentlyActive' | scTranslate | async }}
            </div>
            <div
              *ngIf="radioOption.requested"
              class="bg-black rounded-full px-2 py-0.5 text-xs text-white"
            >
              {{ 'shared.requested' | scTranslate | async }}
            </div>
            <div
              *ngIf="(radioOption.isRequested || intentRequested()) && !radioOption.isActive"
              class="text-white bg-gray-400 text-xs leading-5 px-2 rounded-full"
            >
              {{ 'shared.requested' | scTranslate | async }}
            </div>
          </div>
        </div>
        <div class="text-mobileSm">{{ radioOption.description }}</div>
        <div
          *ngIf="(radioOption.isRequested || intentRequested()) && !radioOption.isActive"
          class="text-xs text-secondaryText mb-1.5 text-left"
        >
          {{ radioOption.message }}
        </div>
      </div>
    </div>
    <div class="flex items-center">
      @if (disabled() && !radioOption.isRequested) {
        <span class="font-light text-mobileMd tablet:text-tabletMd text-grayed-600">
          {{ 'shared.unavailable' | scTranslate | async }}
        </span>
      } @else if (radioOption.customPrice) {
        <div class="text-secondaryText text-mobileMd tablet:text-tabletMd desktop:text-desktopMd">
          {{ radioOption.customPrice }}
        </div>
      } @else if (radioOption.price && radioOption.priceWithDiscount) {
        <div class="flex">
          <div
            class="text-secondaryText text-mobileMd tablet:text-tabletMd desktop:text-desktopMd line-through mr-2.5"
          >
            {{ radioOption.price | currency }}
          </div>
          <div class="!font-semibold text-mobileMd tablet:text-tabletMd desktop:text-desktopMd">
            {{ radioOption.priceWithDiscount | currency }}
          </div>
        </div>
      } @else if (radioOption.price) {
        @if (radioOption.wordToReplacePrice && radioOption.isActive) {
          <span class="font-light text-mobileMd tablet:text-tabletMd text-grayed-600">
            {{ radioOption.wordToReplacePrice }}
          </span>
        } @else {
          <div class="!font-semibold text-mobileMd tablet:text-tabletMd desktop:text-desktopMd">
            {{ radioOption.price | currency }}
          </div>
        }
      }
    </div>
  </button>
}
